interface ValidateIntegerOptions {
  readonly customError?: string;
  readonly nonNegative?: boolean;
  readonly greaterThan?: number;
}

export const validateInteger = (value: string, translate: CallableFunction, options: ValidateIntegerOptions = {}) => {
  const {
    customError,
    nonNegative,
    greaterThan,
  } = options;
  const num = Number(value);

  if (!Number.isInteger(num) || value.trim() === "") {
    return customError || translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideValidInteger");
  }

  if (nonNegative && num < 0) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideAPositiveNumber");
  }

  if (greaterThan !== undefined && greaterThan !== null && num <= greaterThan) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideANumberBiggerThanN", { biggerThan: greaterThan });
  }

  return undefined;
};
